// extracted by mini-css-extract-plugin
export default {"root":"ContactMessage_root__oFigB","link":"ContactMessage_link__HPuEQ"};